var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiPodiumGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 109,
    viewBox: "0 0 120 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2418 31.7628L60.0024 31.6305L59.762 31.7607L48.2817 37.9758L51.3831 26.3341L51.4681 26.0153L51.2083 25.8118L41.318 18.0644L54.3894 17.0301L54.6786 17.0072L54.8023 16.7448L59.996 5.72322L65.0963 16.7417L65.2192 17.0072L65.5108 17.0301L78.6728 18.0643L68.6934 25.8104L68.4346 26.0113L68.5155 26.3288L71.4803 37.9711L60.2418 31.7628ZM25 95.875H25.5V95.375V86.2917V85.7917H25H15H14.5V86.2917V95.375V95.875H15H25ZM105 95.875H105.5V95.375V68.125V67.625H105H95H94.5V68.125V95.375V95.875H95H105ZM45.5 103.958V45.9167H74.5V103.958H45.5ZM34.5 103.958H5.5V77.7083H34.5V103.958ZM114.5 103.958H85.5V59.5417H114.5V103.958Z",
    fill: "#03C988",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiPodiumGold);
export default __webpack_public_path__ + "static/media/mdi_podium-gold.d234e120b041593254175639899300ca.svg";
export { ForwardRef as ReactComponent };